<template>
  <div>
    <div class="container">
      <breadcrumbs :breadcrumbs="breadcrumbs" />
    </div>
    <GuestPriceWarning/>
    <div class="container">
      <div ref="h1Category" class="category-header">
        <h1>{{ getCategoryLocaleData(category).name }}</h1>
      </div>
      <products-list v-if="category.id" :category="category" :seo="seo"/>
    </div>
  </div>
</template>

<script>
import {rememberExpiresMixin, headCatalogMixin} from '@/mixins';
import {DbConfig} from '@/models/db-config';
import {Category} from '@/models/category';
import {Seo} from '@/models/seo';

import Breadcrumbs from '@/components/breadcrumbs';
import ProductsList from '@/components/catalog/products-list';
import GuestPriceWarning from '@/components/catalog/guest-price-warning';

export default {
  components: {
    Breadcrumbs,
    ProductsList,
    GuestPriceWarning,
  },
  mixins: [
    rememberExpiresMixin,
    headCatalogMixin
  ],
  computed: {
    breadcrumbs() {
      let breadcrumbs = [];
      let category = this.category;
      let categoryTree = [category];
      while (category.parent) {
        categoryTree.push(category.parent);
        category = category.parent;
      }
      let categoryUrl = '/';
      for (const category of categoryTree.reverse()) {
        categoryUrl += `${category.slug}/`;
        if (category.parent || categoryTree.length === 1) {
          breadcrumbs.push({
            name: this.getCategoryLocaleData(category).name,
            link: categoryUrl,
          });
        }
      }
      return breadcrumbs;
    },
    slug() {
      const urlParts = this.$route.path.split('/').filter(x => x);
      return urlParts[urlParts.length - 1];
    },
  },
  async asyncData(context) {
    const urlParts = context.route.path.split('/').filter(x => x);
    const slug = urlParts[urlParts.length - 1];
    try {
      const [dbConfig, category] = await Promise.all([
        DbConfig.config({count_loading: true}).first(),
        Category.config({count_loading: true}).find(slug),
      ]);
      const seo = await Seo.config({count_loading: true}).params({category: category.id}).first();
      return {
        dbConfig: dbConfig,
        category: category,
        seo: seo
      }
    } catch (e) {
      context.error({statusCode: e.response.status});
    }
  },
  methods: {
    getCategoryLocaleData(category) {
      return category.category_translations?.find(x => x.language.slug === this.$i18n.locale) || {};
    },
  },
}
</script>
